<!--
 * @Desc: banner切换
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-09 16:16:45
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-Banner">
        <div class="swiper mySwiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,idx) in bannerList" :key="idx">
                    <video
                        v-if="item.type == 2"
                        class="pcVideo"
                        @click="toPath(item)"
                        muted
                        loop
                        playsinline
                        webkit-playsinline
                        x-webkit-airplay
                        x5-video-player-fullscreen
                        x5-video-player-type="h5"
                        :src="$adddom(item.thumb)"
                    ></video>
                    <div class="info" v-if="item.type == 2" style="top:380px;">
                        <!-- <h1 class="title">专注教育 创造未来</h1> -->
                        <!-- <div class="btn-apply" @click="toPath(item)">立即报名<img src="../../../public/statics/images/arr.png"></div> -->
                        <div class="btn-play"></div>
                        <div class="btn-stop"><i style="color:#fff;" class="el-icon-caret-right"></i></div>
                    </div>
                    <img
                        v-if="item.type == 1"
                        :src="$adddom(item.thumb)"
                        @click="toPath(item)"
                    />
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            bannerList: [],
            swiper:''
        };
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {},
    mounted: function () {
        this.getBanner()
        let that = this
        $('.page-Banner').on('click','.btn-play',function(){
            let video = $(this).parent().parent().find('.pcVideo')[0]
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
            $(this).hide()
            $('.page-Banner').find('.btn-stop').show()
        })
        $('.page-Banner').on('click','.btn-stop',function(){
            let video = $(this).parent().parent().find('.pcVideo')[0]
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
            $(this).hide()
            $('.page-Banner').find('.btn-play').show()
        })
    },
    updated: function() {
        $('.page-Banner').find('.btn-play').hide()
        let that = this
        this.$nextTick(()=>{
            if (that.swiper) {
                that.swiper.disable()
                that.swiper = ''
            }
            that.swiper = new Swiper(".mySwiper", {
                pagination: {
                    el: ".swiper-pagination",
                },
                on: {
                    slideChangeTransitionStart: function () {
                        // console.log(this.activeIndex);
                        // console.log($('.pcVideo').length)
                        for(let i=0;i<$('.pcVideo').length;i++){
                            $('.pcVideo')[i].pause()
                        }
                        $('.page-Banner').find('.btn-stop').show()
                        $('.page-Banner').find('.btn-play').hide()
                    },
                    slideChangeTransitionEnd: function () {
                        // console.log(this);
                        // that.activeIndex = this.activeIndex;
                    },
                },
            });
        })
    },
    methods: {
        // 点击轮播跳转
        toPath(item){
            // console.log(item)
            let that = this
            if (item.url == "" || item.url == undefined || item.url == null) {
                // console.log("src地址有问题");
                return false
            }
            if (item.url.substr(0, 4).toLowerCase() === "http") {
                window.open(item.url)
            } else {
                that.$toPath(item.url,{})
            }
        },
        // 获取banner列表
        getBanner(){
            let that = this
            this.$api.index.banner({pos_id:1}).then((res)=>{
                if(res.code == 200) {
                    // console.log(res)
                    that.bannerList = res.result
                }
            })
        }
    },
};
</script>

<style scoped>
.page-Banner {
    width: 100%;
    height: 500px;
}
.swiper {
    min-width: 1200px;
    width: 100%;
    height: 100%;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position:center;
}
.swiper-slide video {
    display: block;
    width: 100%;
    height: 100%;
}
.info {
    position: absolute;
    top: 160px;
    left: 50%;
    transform: translateX(-50%);
}
.info .title {
    font-size: 80px;
    font-family: AppleSystemUIFont;
    color: #FFFFFF;
    white-space: nowrap;
}
.info .btn-apply {
    width: 118px;
    height: 44px;
    background: #1677FF;
    font-size: 14px;
    font-family: PingFangSC;
    color: #ffffff;
    margin: 20px auto 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.info .btn-apply img{
    width: 18px;
    height: 13px;
    margin-left: 13px;
}
.info .btn-play {
    width: 44px;
    height: 44px;
    background: #002140;
    position: relative;
    margin: 0 auto;
}
.info .btn-play::after {
    content: "";
    position: absolute;
    width: 2px;
    height: 13px;
    background: #ffffff;
    top: 50%;
    left: 50%;
    transform: translate(-3px, -50%);
}
.info .btn-play::before {
    content: "";
    position: absolute;
    width: 2px;
    height: 13px;
    background: #ffffff;
    top: 50%;
    left: 50%;
    transform: translate(3px, -50%);
}
.info .btn-stop{
    width: 44px;
    height: 44px;
    background: #002140;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
.page-Banner /deep/ .swiper-pagination-bullet {
    width: 30px;
    height: 4px;
    background: #ffffff;
    border-radius: 3px;
}
.page-Banner
    /deep/
    .swiper-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet,
.page-Banner
    /deep/
    .swiper-pagination-horizontal.swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 6px;
}
.page-Banner /deep/ .swiper-horizontal > .swiper-pagination-bullets,
.page-Banner /deep/ .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 37px;
}
</style>
